import { queryClient } from '@app/core/integrations/react-query/react-query';
import { useFragmentQuery } from '@app/modules/fragments/hooks/useFragment';
import { TranscriptionStart } from '@app/modules/fragments/screens/view/components/transcription/actions/TranscriptionStart';
import { GetFragmentDto, JobStatus, PublicJobDto } from '@mi-front/core';
import { Spinner } from '@mi-front/ui';
import { Alert } from '@mui/material';

interface Props {
  job: PublicJobDto;
  fragment: GetFragmentDto;
}

export function JobStatusAlert({ job, fragment }: Props) {
  const status = job.status;
  const progress = status === JobStatus.IN_PROGRESS ? job.progress : 0;

  return status !== JobStatus.COMPLETED ? (
    <Alert
      sx={{
        '& .MuiAlert-message': {
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
        },
      }}
      severity={(() => {
        return status === JobStatus.FAILED ? 'error' : 'info';
      })()}
    >
      {status === JobStatus.IN_PROGRESS && (
        <>
          <Spinner color={'#555'} />{' '}
        </>
      )}
      {status}
      {typeof progress === 'number' && progress > 0 && ` (${Math.round(progress)}%)`}
      {status === JobStatus.FAILED && (
        <TranscriptionStart
          fragment={fragment}
          retry={true}
          onStarted={() =>
            queryClient.invalidateQueries({
              queryKey: useFragmentQuery.queryKey(fragment.id),
            })
          }
        />
      )}
    </Alert>
  ) : (
    <div />
  );
}
